var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.266 3.42054C14.7227 3.66148 14.1388 3.82432 13.526 3.89756C14.1515 3.52262 14.6319 2.92893 14.8581 2.22155C14.2727 2.56868 13.6244 2.8208 12.9344 2.95669C12.3817 2.36792 11.5944 2 10.7231 2C9.05001 2 7.69358 3.35637 7.69358 5.02936C7.69358 5.26679 7.72043 5.49801 7.77206 5.71972C5.2543 5.59339 3.02209 4.38733 1.52793 2.55453C1.26717 3.00195 1.11777 3.52235 1.11777 4.07752C1.11777 5.12852 1.65264 6.05578 2.46551 6.59902C1.96888 6.5833 1.50179 6.44703 1.09331 6.22013C1.09309 6.23277 1.09309 6.24546 1.09309 6.25821C1.09309 7.726 2.13734 8.95043 3.5232 9.22869C3.26897 9.29793 3.00135 9.33493 2.72503 9.33493C2.52983 9.33493 2.34004 9.31597 2.15511 9.28059C2.54058 10.4842 3.65936 11.36 4.985 11.3845C3.94821 12.197 2.64196 12.6813 1.22266 12.6813C0.978157 12.6813 0.736999 12.667 0.5 12.639C1.84065 13.4985 3.43305 14 5.14384 14C10.716 14 13.7631 9.38386 13.7631 5.38064C13.7631 5.24929 13.7602 5.11863 13.7543 4.98874C14.3462 4.56162 14.8598 4.02805 15.266 3.42054Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwitter);
export default __webpack_public_path__ + "static/media/ic-twitter.748d13397cbe6426fdb1d51c993cf65c.svg";
export { ForwardRef as ReactComponent };